import { apiV2, errorHandler } from './index';
import {
  API_ERROR,
  FETCH_ALL_QUOTES,
  FETCH_ONE_QUOTE,
} from '../constants/ActionTypes';
import Swal from 'sweetalert2';

export function fetchAllQuotes() {
  return function (dispatch) {
    // Return the promise so callers can `.catch()` — without this
    // the v2 page threw "cannot read .catch of undefined".
    return apiV2.get(`/quotes`)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_QUOTES,
          payload: response.data.objects,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR)
      });
  }
}

/**
 * Fetch a single quote by id — uses the Laravel resource show
 * route (GET /quotes/{id}) instead of pulling the entire list.
 * Used by the V2 edit page so /quotes/edit/:id loads in one
 * targeted request.
 */
export function fetchOneQuote(quote_id) {
  return function (dispatch) {
    return apiV2.get(`/quotes/${quote_id}`)
      .then((response) => {
        dispatch({
          type: FETCH_ONE_QUOTE,
          payload: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  }
}

export function clearAllQuotes() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_QUOTES,
      payload: null,
    });
  }
}

export function addEditQuote(quote_json, onSuccess) {
  return function (dispatch) {
    const data = typeof quote_json === 'string' ? JSON.parse(quote_json) : quote_json;
    const request = data.quote_id
      ? apiV2.put(`/quotes/${data.quote_id}`, data)
      : apiV2.post('/quotes', data);

    request
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Quote Saved!',
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR)
      });
  }
}

export function deleteQuote(quote_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/quotes/${quote_id}`)
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Quote Deleted!',
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR)
      });
  }
}
